/* istanbul ignore file */
import React from 'react';
import { useTimer } from '@catalogo/theme-timer';
import { getIn } from 'seamless-immutable';
import { withCookies } from '@catalogo/core-connect/cookies';
import styled from 'styled-components';
import Clock from '@catalogo/ui-americanas-desktop-svg/clock.svg';

const ChronometerUI = ({ option }) => {
  const salesClose = getIn(option, ['details', 'shipstoreSalesClosingTime']);
  const closeHour = parseInt(salesClose.split(':')[0]);
  const closeMin = parseInt(salesClose.split(':')[1]);
  const closeDate = new Date().setHours(closeHour, closeMin);
  const closeLimit = new Date(closeDate).toLocaleString('pt-BR');

  const timer = useTimer(closeLimit);
  const { hours, minutes, seconds } = timer;

  const countDown = `${hours}:${minutes}:${seconds}`;
  const isInitial = countDown === '00:00:00';

  return (
    <View>
      <ClockUI height="14" width="14" />
      <Text>
        comprando em até <strong>{isInitial ? '--:--:--' : countDown}</strong>
      </Text>
    </View>
  );
};

const View = styled.div`
  display: flex;
  align-items: center;
  padding-top: 3px;
  margin-top: 5px;
`;

const Text = styled.span`
  color: #006400;
`;

const ClockUI = styled(Clock)`
  margin-right: 5px;
  fill: #006400;
`;

export const Chronometer = props => <ChronometerUI {...props} />;

export default withCookies(Chronometer);
